import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { ArrowLeft } from 'lucide-react';
import { setFavicon } from '../lib/favicon';

export default function ComingSoon({ title }) {
  useEffect(() => {
    document.title = `${title} | Nova Stron Grup`;
    setFavicon('/grup/favicon-grup.png');
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div data-testid="coming-soon-page" className="min-h-screen bg-[#f4f2ee] text-[#1c1c1c] flex flex-col">
      <header className="px-6 sm:px-10 lg:px-16 pt-8 lg:pt-10">
        <Link to="/" data-testid="coming-soon-logo-link">
          <img src="/grup/logo.png" alt="Nova Stron Grup" className="h-16 sm:h-20 w-auto" />
        </Link>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center text-center px-6 py-20">
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-xs tracking-[0.4em] uppercase text-[#1c1c1c]/50 mb-6"
        >
          Nova Stron Grup
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-light uppercase tracking-[0.15em] text-3xl sm:text-4xl lg:text-6xl"
          data-testid="coming-soon-title"
        >
          {title}
        </motion.h1>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="mt-8"
        >
          <span className="text-lg sm:text-xl tracking-[0.5em] uppercase text-[#cab28e] font-medium">Uskoro</span>
          <p className="mt-6 text-sm text-[#1c1c1c]/60 max-w-md mx-auto leading-relaxed">
            Stranica je u izradi. Za sve upite kontaktirajte nas na{' '}
            <a href="mailto:info@nova-stron.eu" className="underline hover:text-[#1c1c1c]" data-testid="coming-soon-email">
              info@nova-stron.eu
            </a>
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.5 }}
        >
          <Link
            to="/"
            data-testid="coming-soon-back-link"
            className="inline-flex items-center gap-2 mt-12 text-xs tracking-[0.25em] uppercase text-[#1c1c1c]/70 hover:text-[#1c1c1c] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={1.2} /> Natrag na početnu
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
